import React, {useEffect, useState} from "react";
import {Modal} from 'react-bootstrap';
import {Link} from "react-router-dom";
import {getResource} from "../service/http-service";


export const InfoModal = (props) => {

    const [isEducationTrue, setIsEducationTrue] = useState(false)

    useEffect(() => {
        getResource('candidates/check_education').then((data) => {
            setIsEducationTrue(data.data);
        })
    },[])




    let user = sessionStorage.getItem('user')
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <>
            <div onClick={handleShow} className={props.btnClass}>
                {props.btnText}
            </div>
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{props.recruitment.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {(user && isEducationTrue) ?  <p>Дали сте сигурни дека сакате да аплицирате на огласот?</p> :
                        (user && !isEducationTrue) &&  <p>За да аплицирате на оглас внесете го вашето образование</p>}
                    {!user &&  <p>За да аплицирате на огласот морате да се најавите на апликацијата</p>}
                </Modal.Body>
                <Modal.Footer>
                    {(user && isEducationTrue) ?  <div className="d-flex justify-content-between w-100">
                        <div
                            className={props.btnClass}
                            onClick={handleClose}>
                            Затвори
                        </div>
                        <div
                            className={props.btnClass}
                            onClick={(e)=> {
                                const isPasswordChanged = sessionStorage.getItem('changePassword')
                                if (isPasswordChanged === 'true') {
                                    window.location.replace("/career_opportunities/change_password")
                                } else {
                                    props.handleSave(props.recruitment)
                                    handleClose()
                                }
                            }
                            }>Аплицирај</div>
                    </div> : (user && !isEducationTrue) ?
                        <div className="d-flex justify-content-around align-items-center w-100">
                            <div
                                className={props.btnClass}
                                onClick={handleClose}>
                                Затвори
                            </div>
                                <Link to="/career_opportunities/profile"
                                      className="header-button-logIn w-100">
                                    <div className={props.btnClass}>Мој профил</div>
                                </Link>
                           </div> :  <div className="d-flex justify-content-around align-items-center w-100">
                            <div
                                className={props.btnClass}
                                onClick={handleClose}>
                                Затвори
                            </div>
                            <Link to="/career_opportunities/login" className="header-button-logIn w-100">
                                <div className={props.btnClass}> Најави се</div>
                            </Link>
                        </div>
                            }
                </Modal.Footer>
            </Modal>
        </>
    );
}